import React, { createContext, useReducer } from 'react';

export const initialState = {
  page: 0,
  rowsPerPage: 10,
  orderBy: 'Name',
  order: 'asc',
  metricNameFilter: ''
};

export const DispatchContext = createContext(null);
export const StateContext = createContext(initialState);

export const reducer = (state, action) => {
  switch (action.type) {
    case 'setPage':
      return { ...state, page: action.payload };
    case 'setRowsPerPage':
      return { ...state, rowsPerPage: action.payload, page: initialState.page };
    case 'setOrder':
      return { ...state, order: action.payload.order, orderBy: action.payload.orderBy };
    case 'setMetricNameFilter':
      const changed = state.metricNameFilter !== action.payload;
      const empty = !action.payload || action.payload.length === 0;
      return {
        ...state,
        metricNameFilter: action.payload,
        page: changed ? initialState.page : state.page,
        orderBy: empty ? initialState.orderBy : null,
        order: empty ? initialState.order : state.order
      };
    default:
      throw new Error();
  }
};

const AllMetricsContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <DispatchContext.Provider value={dispatch}>
      <StateContext.Provider value={state}>{props.children}</StateContext.Provider>
    </DispatchContext.Provider>
  );
};

export default AllMetricsContextProvider;
